import * as React from 'react'

export default () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="3" r="3" fill="#3C52EF" />
    <path d="M10 11C6 11 4 11 0 11C0 8.23858 2.23858 6 5 6C7.76142 6 10 8.23858 10 11Z" fill="#3C52EF" />
    <path d="M10 6V12" stroke="white" strokeWidth="3" />
    <path d="M12 9L7 9" stroke="white" strokeWidth="4" strokeLinecap="round" />
    <path d="M10 6V12" stroke="#3C52EF" strokeWidth="1.5" />
    <path d="M13 9L7 9" stroke="#3C52EF" strokeWidth="1.5" />
  </svg>
)
